import type { PolicyAcceptanceStatus, PolicyOutstandingReason } from '@grc/types';
import type { BadgeTone } from '../../components/ui.js';

/**
 * Policy acceptance query keys share one prefix so that accepting, publishing,
 * recording or reminding can invalidate everything in one call.
 */
export const policiesKey = (orgId: string) => ['policies', orgId] as const;
export const myPoliciesKey = (orgId: string) => ['policies', orgId, 'mine'] as const;
export const releaseKey = (orgId: string, releaseId: string) =>
  ['policies', orgId, 'release', releaseId] as const;
export const matrixKey = (orgId: string) => ['policies', orgId, 'matrix'] as const;
export const releasesKey = (orgId: string, corpusItemId: string) =>
  ['policies', orgId, 'releases', corpusItemId] as const;
export const registerKey = (orgId: string) => ['policies', orgId, 'register'] as const;

export const STATUS_META: Record<PolicyAcceptanceStatus['status'], { label: string; tone: BadgeTone }> = {
  accepted: { label: 'Accepted', tone: 'success' },
  outstanding: { label: 'Outstanding', tone: 'warning' },
  overdue: { label: 'Overdue', tone: 'danger' },
};

/** Sub-label explaining why an acceptance is outstanding. */
export function reasonLabel(
  reason: PolicyOutstandingReason | null,
  reacceptIntervalMonths: number | null,
): string | null {
  if (reason === 'new_version') return 'New version';
  if (reason === 'periodic') {
    return reacceptIntervalMonths === 12 ? 'Annual reconfirmation' : 'Periodic reconfirmation';
  }
  return null;
}

/** Today as YYYY-MM-DD (UTC, matching the API's date checks). */
export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
